<script>
import { GlEmptyState } from '@gitlab/ui';
import { s__ } from '~/locale';

export default {
  name: 'SuggestionsPlaceholder',
  components: {
    GlEmptyState,
  },
  i18n: {
    title: s__('DuoAgentsPlatform|Suggestions'),
    description: s__('DuoAgentsPlatform|Code suggestions will appear here.'),
  },
};
</script>

<template>
  <gl-empty-state :title="$options.i18n.title" :description="$options.i18n.description" />
</template>
